// extracted by mini-css-extract-plugin
export default {"select":"Select_select__TGd1G","active":"Select_active__MHK1r","empty":"Select_empty__qeMfd"};